<script setup>
import { API } from '@/services/index';
import { GET_ENUMS_QUERY } from '@/services/common/queries.js';
import { useQuery } from '@tanstack/vue-query';
import { useSetupStore } from '@/stores/setup.store.js';
import AuthFormLayout from '@/components/auth/authFormLayout.vue';
import partnrUpLogo from '@/assets/logo/PartnrUP_Full.svg';

const setupStore = useSetupStore();

const { data } = useQuery({
  queryKey: ['getEnums'],
  queryFn: async () => {
    const res = await API.sendQuery('/graphql', GET_ENUMS_QUERY, { name: 'ACLRoleEnum' });
    if (res.data.data.getEnums) {
      setupStore.setAccountTypes(res.data.data.getEnums);
    }
    if (res.data.data.errors) {
      console.log('get enums error', res.data.data.errors);
    }
    return data;
  }
});
</script>

<template>
  <!--  <AuthFormLayout :height="696">-->
  <AuthFormLayout>
    <div class="tw-h-full tw-w-full tw-p-4">
      <div class="tw-relative tw-h-full">
        <img class="tw-mx-auto tw-w-[142px]" :src="partnrUpLogo" alt="PartnrUp" />
        <router-view v-slot="{ Component }">
          <transition mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </AuthFormLayout>
</template>

<style scoped></style>
